export default {
    星财宝专户: '星財寶專戶',
    offline: {
        title: '星財寶專戶已下線',
        message: '請更新至最新版本的app後查看。',
    },
    确定: '確定',
    lang: 'zhTc',
    请在方框内横向正楷签署你的名字: '請在<span style="color: #ff6907;">方框内</span>橫向正楷簽署你的名字：',
    前往认证: '前往認證',
    前往认证popText: '尊敬的客戶，星財寶專戶相關服務僅對專業投資者開放，根據監管要求，您需要提供800萬港元資產的認證',
    查看进度: '查看進度',
    查看进度popText: '尊敬的客戶，您已提交專業投資者認證申請，點擊下方按鈕查看申請進度',
    请勾选协议: '請勾選協議',
    agreement: {
        title: '【星財寶專戶】服務由【復星國際資產管理有限公司】提供',
        本人已阅读并同意: '本人已閱讀並同意',
        星财宝专户全权委托投资管理协议: '《星財寶專戶全權委託投資管理協議》',
        及签署理财账户: '及簽署理財賬戶',
        已确认: '已確認',
        去测评: '去測評',
        提示: '提示',
        '您尚未完成风险测评，无法开通星财宝专户相关服务，请尽快测评': '您尚未完成風險測評，無法開通星財寶專戶相關服務，請儘快測評',
        '您的风险测评结果已过期，无法开通星财宝专户相关服务，请尽快重新测评': '您的風險測評結果已過期，無法開通星財寶專戶相關服務，請儘快重新測評',
        重新测评: '重新測評',
        您当前的风险等级为: '您當前的風險等級為',
        riskServer: '，星財寶專戶服務的風險等級與您的風險承受能力不匹配，無法開通相關服務',
        '您尚未开通理财账户，是否完成风险测评并开通？': '您尚未開通理財賬戶，是否完成風險測評並開通？',
        本人已阅读并同意签署: '本人已閱讀並同意簽署',
        客户协议书: '《客戶協議書》',
        请设置交易密码: '為保障您的賬號安全，請設定交易密碼',
        前往设置: '前往設定',
        稳健型: '穩健型(1級別)',
        中度型: '中度型(2級別)',
        均衡型: '均衡型(3級別)',
        增长型: '增長型(4級別)',
        进取型: '進取型(5級別)',
    },
    riskDisclosure: {
        风险披露: '風險披露',
        请点击下方播放按钮听取完整风险披露音频: '請點擊下方播放按鈕聽取完整風險披露音頻',
        我已确认自愿签署: '我已確認自願簽署',
        xieyi: '《星財寶專戶全權委託投資管理協議》',
        我已确认及同意使用和接收电子签名于: '我已確認及同意使用和接收電子簽名於',
        我已确认及明白: '我已確認及明白【星財寶專戶】服務所涉及的風險，包括固定收益工具風險、法律與政策風險、資訊披露風險等',
        我已全权委托: '我已全權委託【復星國際資產管理有限公司】為我管理【星財寶專戶】，該專戶服務以現金管理為目的，專戶的投資範圍具體參見',
        载明的范围: '載明的範圍',
        复星国际证券持牌代表: '復星國際證券持牌代表',
        资管持牌代表: '復星國際資管持牌代表',
        下一步: '下一步',
        ypjzz: '音頻加載中',
        音频加载中: '音頻加載中',
        图片加载中: '圖片加載中',
        bs: '倍速',
        0: '普',
        1: '粵',
    },

    本人已阅读并同意签署:
        '本人已閱讀並同意簽署《星財寶專戶全權委託投資管理協議》，其中包括《客戶聲明及確認》《附件A:費用表》《附件B-投資策略》《附件 C – 投資交易第三者指示授權／彌償書》、《附件 D - (星財寶) 貨幣基金自動買入及贖回服務協定》',
    status: {
        联系客服: '聯繫客服',
        资料审核不通过: '資料審核不通過',
        重新签名: '重新簽名',
        开通失败: '星財寶專戶開通失敗',
        重新申请: '重新申請',
        开通成功: '星財寶專戶開通成功',
        账户号码: '星財寶專戶號碼',
        买入产品: '買入產品',
        资料审核中: '星財寶專戶開戶資料審核中',
        '预计1-2个工作日开通': '預計1-2個工作日開通',
        完成: '完成',
    },
    sendPage: {
        srdxyzm: '輸入短信驗證碼',
        yfsdxyzmz: '已發送短訊驗證碼至：',
        cxfs: '重新發送',
        sbdyzm: '收不到驗證碼',
        nkylxkfjxyzmcx: '您可以聯繫客服進行驗證碼查詢。',
        dlkf: '内地客服：',
        xgkf: '香港客服：',
        qsrzqdyzmzsyc: '驗證碼錯誤或失效，請重新輸入',
        zdl: '知道了',
        获取语音验证码: '獲取語音驗證碼',
        '我们将通过电话语音告知您验证码，请留意接听。': '我們將通過電話語音告知您驗證碼，請留意接聽。',
        '如仍无法收到，可': '如仍無法收到，可',
        联系客服: '聯繫客服',
        '语音验证码已发送，请留意接听电话': '語音驗證碼已發送，請留意接聽電話',
        重新获取: '重新獲取',
        输入语音验证码: '輸入語音驗證碼',
        我们正在打电话至: '我們正在打電話至：',
        电话将提供验证码: '，電話將提供驗證碼',
        '语音验证码获取频率过高，请稍后再试': '語音驗證碼獲取頻率過高，請稍後再試',
        联系我们: '聯繫我們',
    },
    eSignInnerHtml: `<h1>關於使用電子簽名的同意書</h1><h2>1)同意範圍</h2><p>本人在此不可撤銷地同意及授權復星國際證券有限公司（“貴公司”），就本人與貴公司進行之{userName}，使用電子簽名方式以取代傳統之親筆書面簽名。</p><h2>2)電子簽名之定義及方法</h2><p>本同意書所指之“電子簽名”，是依據香港法例第553章《電子交易條例》所界定之方式，為識別本人身份及表明本人認證或批准相關電子紀錄之目的而所用之方法。該方法包括但不限於：</p><ul><li>a)在貴公司提供之應用程程（APP）內，通過預先驗證之登錄程序（如交易密碼、一次性短信驗證碼）後，點擊“確認”、“同意”或“簽署”按鈕；</li><li>b)貴公司認為可靠且適當之其他電子認證方式。</li></ul><h2>3)法律效力</h2><p>本人明確承認並同意，根據《電子交易條例》，以此方式產生之電子簽名完全滿足任何法律要求籤名之規定，並與本人親筆書寫之簽名具有同等之法律效力。本人承諾不會以簽名僅為電子形式為由，質疑該等已簽署文件之法律有效性、可執行性或其作為證據之效力。</p><h2>4)確認為本人操作</h2><p>本人明白，通過本人賬戶交易密碼及驗證後於APP進行之任何電子簽署操作，均視為本人本人之行為，並由本人承擔由此產生之一切法律後果。</p><h2>5)同意之持續性</h2><p>本同意持續有效，直至本人以書面形式通知貴公司終止此項同意為止。惟在該終止生效前已完成之電子簽署行為，其法律效力不受影響。</p><h2>6)查閱與保存</h2><p>本人同意貴公司以電子紀錄方式保存及管理以此方式簽署之所有文件，並可應本人要求提供該等文件之副本。</p>`,
}
